export const EVENTS = {
    PUSHSTATE: 'pushstate',
    POPSTATE: 'popstate'
}

export const BUTTONS = {
    primary: 0
}